import React, { Component } from 'react';
import { Col, Row } from 'antd';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Translation } from 'react-i18next';
import WalletMenuComponent from '../WalletMenuComponent';
import { PREFIX_FRONT_URL } from '../../consts';
import AccountBalanceContainer from '../../containers/AccountBalanceContainer';
import { DepositContainer, WithdrawalContainer, DepositAndWithdrawalContainer } from '../../containers/TransactionContainer';
import AccountSecurityComponent from '../AccountSecurityComponent';
import { OpenOrderContainer, OrderHistoryContainer } from '../../containers/OrderContainer';
import { OrderTransactionHistoryContainer } from '../../containers/OrderTransactionHistoryContainer';
import { UserLoginHistoryContainer } from '../../containers/UserLoginHistoryContainer';
import OrderHistoryComponent from '../OrderHistoryComponent';
import FooterComponent from '../common/FooterComponent';
import './walletStyle.scss';
import CommissionHistoryContainer from '../../containers/CommissionHistoryContainer';

class WalletComponent extends Component {
  render() {
    return (
      <Router>
        <Translation>
          {(t) => (
            <div className="wallet-container">
              <div className="wrap-balance pl-none">
                <Row className="m-0">
                  <Col span={5}>
                    <WalletMenuComponent />
                  </Col>
                  <Col span={19} className="wallet-right-component" style={{ paddingRight: 0 }}>
                    <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.USER_SECURITY}`}>
                      <div className="wallet-right-content">{t('user.menu.user_security')}</div>
                      <AccountSecurityComponent />
                    </Route>
                    <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.USER_WALLET}`}>
                      <AccountBalanceContainer />
                    </Route>
                    <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.DEPOSIT}`}>
                      <DepositContainer />
                    </Route>
                    <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.WITHDRAW}`}>
                      <div className="wallet-right-content">{t('user.menu.withdrawal')}</div>
                      <WithdrawalContainer />
                    </Route>
                    <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.DEPOSIT_WITHDRAWAL}`}>
                      <div className="wallet-right-content">{t('user.menu.deposit_history')}</div>
                      <DepositAndWithdrawalContainer />
                    </Route>
                    <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.OPEN_ORDER}`}>
                      <div className="wallet-right-content">{t('user.menu.open_orders')}</div>
                      <OpenOrderContainer />
                    </Route>
                    <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.ORDER_HISTORY}`}>
                      <div className="wallet-right-content">{t('user.menu.order_history')}</div>
                      <OrderHistoryContainer />
                    </Route>
                    <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.ORDER_TRANS_HISTORY}`}>
                      <div className="wallet-right-content">{t('user.menu.order_trans_history')}</div>
                      <OrderTransactionHistoryContainer />
                    </Route>
                    <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.USER_LOGIN_HISTORY}`}>
                      <div className="wallet-right-content">{t('user.menu.user_login_history')}</div>
                      <UserLoginHistoryContainer />
                    </Route>
                    <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.USER_COMMISSION_HISTORY}`}>
                      <div className="wallet-right-content">{t('user.menu.commission_history')}</div>
                      <CommissionHistoryContainer />
                    </Route>
                  </Col>
                </Row>
              </div>
              <div className="footer">
                <FooterComponent />
              </div>
            </div>
          )}
        </Translation>
      </Router>
    );
  }
}

export default WalletComponent;
